import { isValidEmail } from "@redotech/email/address";
import * as z from "zod";

export const CUSTOM_ANALYTICS_REPORT_SCHEDULE_MAX_CRON_EXPRESSION_LENGTH = 100;
export const CUSTOM_ANALYTICS_REPORT_SCHEDULE_MAX_EMAIL_ADDRESSES = 50;

export const CustomAnalyticsReportScheduleEmailAddressSchema = z
  .string()
  .trim()
  .max(320)
  .refine(isValidEmail, { message: "Invalid email address" })
  .transform((emailAddress) => emailAddress.toLowerCase());

export const CustomAnalyticsReportScheduleEmailAddressesSchema = z
  .array(CustomAnalyticsReportScheduleEmailAddressSchema)
  .max(CUSTOM_ANALYTICS_REPORT_SCHEDULE_MAX_EMAIL_ADDRESSES)
  .transform((emailAddresses) => [...new Set(emailAddresses)]);

export const CustomAnalyticsReportScheduleSchema = z.object({
  cronExpression: z
    .string()
    .min(1)
    .max(CUSTOM_ANALYTICS_REPORT_SCHEDULE_MAX_CRON_EXPRESSION_LENGTH),
  emailDeliveryEnabled: z.boolean(),
  emailAddresses: CustomAnalyticsReportScheduleEmailAddressesSchema,
  sftpDeliveryEnabled: z.boolean(),
  nextRunAt: z.date().nullable(),
  updatedAt: z.date(),
});

export type CustomAnalyticsReportSchedule = z.infer<
  typeof CustomAnalyticsReportScheduleSchema
>;
